import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function PricingCards() {
  return <section id="pricing" className="py-20 px-4" data-id="element-213">
      <div className="max-w-5xl mx-auto" data-id="element-214">
        <div className="text-center mb-16" data-id="element-215">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4" data-id="element-216">
            ELEGÍ TU MEGAPACK
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch" data-id="element-217">
          {/* Card 1: Recommended */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="relative bg-dark-card border-2 border-gold rounded-2xl p-8 flex flex-col shadow-[0_0_40px_rgba(212,168,67,0.15)] md:-mt-4 md:mb-4 z-10" data-id="element-218">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gold text-dark font-bold px-6 py-1.5 rounded-full text-sm tracking-widest flex items-center gap-2 shadow-lg" data-id="element-219">
              <span data-id="element-220">⭐</span> RECOMENDADO
            </div>

            <div className="text-center mb-8 mt-4" data-id="element-221">
              <h3 className="text-2xl font-heading font-bold text-white mb-2" data-id="element-222">
                🏆 MEGAPACK + PROTOCOLO DE EMERGENCIA
              </h3>
              <p className="text-gold-light font-medium" data-id="element-223">
                6 Tomos + 6 Bonos + PNL en 24 Horas
              </p>
            </div>

            <div className="bg-dark/50 rounded-lg p-4 mb-8 border border-dark-border" data-id="element-224">
              <p className="text-sm text-gray-300 text-center" data-id="element-225">
                <span className="font-bold text-white" data-id="element-226">Ideal para:</span>{' '}
                Transformarte en profundidad Y tener herramientas de acción
                rápida para el día a día argentino
              </p>
            </div>

            <div className="text-center mb-8" data-id="element-227">
              <div className="text-gray-500 line-through mb-1" data-id="element-228">
                Valor real: $89.000
              </div>
              <div className="text-sm text-gold font-bold tracking-widest mb-1" data-id="element-229">
                PRECIO HOY:
              </div>
              <div className="text-5xl font-heading font-bold text-white" data-id="element-230">
                $27.990 <span className="text-2xl text-gray-400" data-id="element-231">ARS</span>
              </div>
            </div>

            <div className="mt-auto" data-id="element-232">
              <motion.a href="https://academiaholisticaargentina.com/cart/48581166956761:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="block w-full py-4 text-center bg-gradient-to-r from-gold to-gold-light text-dark font-bold text-lg rounded-lg shadow-[0_0_20px_rgba(212,168,67,0.3)] hover:shadow-[0_0_30px_rgba(212,168,67,0.5)] transition-all" data-id="element-233">
                → QUIERO EL MEGAPACK COMPLETO
              </motion.a>
            </div>
          </motion.div>

          {/* Card 2: Standard */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-dark-lighter border border-dark-border rounded-2xl p-8 flex flex-col hover:border-gold/30 transition-colors" data-id="element-234">
            <div className="text-center mb-8 mt-4 md:mt-0" data-id="element-235">
              <h3 className="text-2xl font-heading font-bold text-white mb-2" data-id="element-236">
                📘 MEGAPACK SISTEMA SOBERANO
              </h3>
              <p className="text-gray-400 font-medium" data-id="element-237">6 Tomos + 6 Bonos</p>
            </div>

            <div className="bg-dark/50 rounded-lg p-4 mb-8 border border-dark-border" data-id="element-238">
              <p className="text-sm text-gray-300 text-center" data-id="element-239">
                <span className="font-bold text-white" data-id="element-240">Ideal para:</span>{' '}
                Reprogramarte completamente con el sistema más completo de PNL
                aplicada a Argentina
              </p>
            </div>

            <div className="text-center mb-8" data-id="element-241">
              <div className="text-gray-500 line-through mb-1" data-id="element-242">
                Valor real: $69.000
              </div>
              <div className="text-sm text-gray-400 font-bold tracking-widest mb-1" data-id="element-243">
                PRECIO HOY:
              </div>
              <div className="text-5xl font-heading font-bold text-white" data-id="element-244">
                $19.990 <span className="text-2xl text-gray-400" data-id="element-245">ARS</span>
              </div>
            </div>

            <div className="mt-auto" data-id="element-246">
              <motion.a href="https://academiaholisticaargentina.com/cart/48581160468697:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="block w-full py-4 text-center bg-dark-card border border-gold/50 text-gold-light hover:bg-gold/10 font-bold text-lg rounded-lg transition-all" data-id="element-247">
                → QUIERO MI MEGAPACK
              </motion.a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}